export default __webpack_public_path__ + "static/media/141.8dc325d0.png";